import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FaqItem from 'ggApp/shared/common/Faq/Item';

class Block extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItemIndex: null,
        };
    }

    handleItemClick = (index) => {
        const { activeItemIndex } = this.state;
        if (activeItemIndex === index) {
            this.setState({ activeItemIndex: null });
        } else {
            this.setState({ activeItemIndex: index });
        }
    };

    render() {
        const {
            withHtml,
            className,
            content,
            shouldShowIndicator,
            withIcons,
            sectionTitle,
            faqStyle,
        } = this.props;
        const { activeItemIndex } = this.state;
        return (
            <div className={className}>
                {sectionTitle}
                {content &&
                    content.map((item, index) => (
                        <FaqItem
                            key={item?.id ?? item.title}
                            isActive={index === activeItemIndex}
                            index={index}
                            handleItemClick={this.handleItemClick}
                            withIcons={withIcons}
                            title={item.title}
                            description={item.description}
                            faqStyle={faqStyle}
                            withHtml={withHtml}
                            shouldShowIndicator={shouldShowIndicator}
                        />
                    ))}
            </div>
        );
    }
}

Block.propTypes = {
    className: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.object),
    withIcons: PropTypes.bool,
    sectionTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    faqStyle: PropTypes.string,
    withHtml: PropTypes.bool,
    shouldShowIndicator: PropTypes.bool,
};

Block.defaultProps = {
    className: '',
    content: [],
    withIcons: false,
    sectionTitle: '',
    faqStyle: '',
    withHtml: true,
    shouldShowIndicator: true,
};

export default Block;
